import axios from "axios";

export const getPayGateConfiguration = () => axios.get('/content/get-payget-connect');
export const getPaymentGateway = () => axios.get('/api/v1/payment-gateway');

